exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subtitle[data-v-001b4ebc]{text-align:center;margin:-1.85rem auto 2rem}.is_checkout_promo .popup_in[data-v-001b4ebc]{background:rgba(0,0,0,.7)}.is_checkout_promo .goto-checkout[data-v-001b4ebc]{text-align:center}.is_checkout_promo .goto-checkout a[data-v-001b4ebc]{margin-top:0;margin-bottom:1rem;padding:0 1rem;white-space:nowrap;display:inline-block;width:auto;cursor:pointer}", ""]);

// exports
